import { render, staticRenderFns } from "./CompanyDataUpdateMessages.vue?vue&type=template&id=56085915&scoped=true&"
import script from "./CompanyDataUpdateMessages.vue?vue&type=script&lang=js&"
export * from "./CompanyDataUpdateMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56085915",
  null
  
)

export default component.exports